import React from 'react';

const OPTIONS = [
    { value: 'ALL', label: 'Tất cả' },
    { value: 'SYSTEM', label: 'SYSTEM' },
    { value: 'NORMAL', label: 'NORMAL' },
];

/**
 * Filter "Loại" gắn NGAY tiêu đề cột Loại của bảng.
 *
 * - Nút ▾ LUÔN hiện (không cần trỏ chuột, không badge, không nút ✕).
 * - Khi đang lọc, tiêu đề cột đổi thành chính giá trị đang lọc
 *   (vd chọn SYSTEM -> tiêu đề "Loại" thành "SYSTEM") cho trực quan.
 * - Bấm ▾ mở menu: Tất cả / SYSTEM / NORMAL. Muốn bỏ lọc -> chọn "Tất cả".
 */
export default function LoaiHeaderFilter({ value, onChange, label = 'Loại' }) {
    const active = !!value && value !== 'ALL';

    return (
        <th className={'align-middle loai-th' + (active ? ' is-active' : '')} scope="col">
            <span className="loai-th-label">{active ? value : label}</span>
            <span
                className="loai-th-btn"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                title="Lọc theo loại"
            >▾</span>
            <div className="dropdown-menu" data-boundary="window">
                {OPTIONS.map((o) => (
                    <a
                        key={o.value}
                        href="#!"
                        className={'dropdown-item' + (value === o.value ? ' active' : '')}
                        onClick={(e) => {
                            e.preventDefault();
                            onChange(o.value);
                        }}
                    >{o.label}</a>
                ))}
            </div>
        </th>
    );
}
